<script setup>
import { ref, computed, watch } from "vue";

import { useStore } from "vuex";

import config from "@/app/config.js";
import SnsModal from "@/components/ui/SnsModal.vue";

const props = defineProps({
  isModalOn: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["close"]);

const store = useStore();
const isLoading = ref(false);

const user = computed(() => store.getters.getUser);
const portalId = computed(() => config.VITE_APP_HUBSPOT_PORTAL_ID);
const formId = computed(() => config.VITE_APP_HUBSPOT_FORM_ID);

const createHubSpotForm = () => {
  if (!portalId.value || !formId.value) {
    // TODO add notify here
    console.error("HubSpot portal ID or form ID is not set");
    handleClose();

    return;
  }

  const script = document.createElement("script");
  script.src = "//js.hsforms.net/forms/v2.js";
  script.charset = "utf-8";
  script.type = "text/javascript";
  document.body.appendChild(script);

  script.onload = () => {
    if (window.hbspt) {
      try {
        window.hbspt.forms.create({
          portalId: portalId.value,
          formId: formId.value,
          region: "na1",
          target: "#hubspotForm",
          onFormReady: (form) => {
            isLoading.value = false;
            prefillForm(form);
          },
          onBeforeFormSubmit: (form) => {
            const emailInputElement = form.querySelector(`#email-${formId.value}`);

            if (emailInputElement) {
              emailInputElement.disabled = false;
            }
          },
          onFormSubmitted: () => {
            // TODO Add notify here
            return false;
          },
        });
      } catch (error) {
        // TODO Add notify here
        console.error("HubSpot form error:", error);
        isLoading.value = false;
      }
    }
  };
};

const prefillForm = (form) => {
  const emailInputElement = form.querySelector(`#email-${formId.value}`);
  const actionsElement = form.querySelector(".actions");

  if (actionsElement) {
    actionsElement.style.paddingBottom = "0";
    actionsElement.style.marginBottom = "0";
  }

  if (emailInputElement) {
    emailInputElement.value = user.value?.email;
    emailInputElement.defaultValue = user.value?.email;
    emailInputElement.dispatchEvent(new Event("input", { bubbles: true }));
    emailInputElement.dispatchEvent(new Event("change", { bubbles: true }));
    emailInputElement.dispatchEvent(new Event("blur", { bubbles: true }));
    emailInputElement.disabled = true;
  }
};

const resetForm = () => {
  const scripts = document.querySelectorAll('script[src*="hsforms.net"]');
  scripts.forEach((script) => script.remove());
  isLoading.value = false;
};

const handleClose = () => {
  emit("close");
};

watch(
  () => props.isModalOn,
  (newValue) => {
    if (newValue) {
      isLoading.value = true;
      createHubSpotForm();
    } else {
      resetForm();
    }
  },
);
</script>

<template>
  <sns-modal :is-modal-on="isModalOn" modal-id="support-modal" size="!w-[640px] !max-w-2xl" @close="handleClose">
    <template #modal-header>
      <div class="flex justify-between items-center w-full font-bold text-base-content">
        {{ $t("common.label.helpAndSupport") }}
        <button
          type="button"
          class="text-neutral dark:text-neutral/80 hover:text-base-content hover:bg-base-200 dark:hover:bg-base-200 p-1 rounded-md focus:outline-none transition-all duration-200"
          @click="handleClose"
        >
          <i class="bi-x-lg text-xl" />
        </button>
      </div>
    </template>

    <template #modal-body>
      <div v-show="isLoading" class="flex flex-col gap-2">
        <div class="skeleton w-full h-20" />
        <div class="skeleton w-full h-20" />
        <div class="skeleton w-full h-60" />
        <div class="flex justify-end">
          <div class="skeleton w-20 h-10" />
        </div>
      </div>

      <div v-show="!isLoading" id="hubspotForm" class="bg-white p-4" />
    </template>
  </sns-modal>
</template>
